import { NoDataComponent, STATUSPAGE } from '@repo/ui';
import ptBr from 'apexcharts/dist/locales/pt-br.json';
import { PerformanceReportForProfessionalsEvolutionItem } from 'presentation/app/modules/Reports/models/performance-report-for-professionals';
import ApexChart from 'react-apexcharts';
import Skeleton from 'react-loading-skeleton';
import { Card, CardBody, CardHeader } from 'reactstrap';

interface IProps {
  loading: STATUSPAGE;
  evolution: PerformanceReportForProfessionalsEvolutionItem[];
}

export const ValidatedActivitiesEvolutionChart = ({
  loading,
  evolution,
}: IProps) => {
  if (loading === STATUSPAGE.LOADING) {
    return (
      <Card>
        <CardHeader className="border-bottom">
          <h5 className="mb-0 text-body">Evolução das atividades validadas</h5>
        </CardHeader>
        <CardBody className="mb-1">
          <Skeleton
            baseColor="#e8e8e8c5"
            highlightColor="#bababa96"
            style={{ height: '350px', width: '100%' }}
            count={1}
          />
        </CardBody>
      </Card>
    );
  }

  return (
    <Card className="h-100">
      <CardHeader className="border-bottom">
        <h5 className="mb-0 text-body">Evolução das atividades validadas</h5>
      </CardHeader>
      <CardBody>
        {evolution.length === 0 ? (
          <div className="justify-content-center align-items-center d-flex h-100">
            <NoDataComponent />
          </div>
        ) : (
          <ApexChart
            type="line"
            height={320}
            options={{
              chart: {
                locales: [ptBr],
                defaultLocale: 'pt-br',
                toolbar: {
                  show: false,
                },
              },
              colors: ['#22C55E'],
              stroke: {
                curve: 'straight',
                width: 3,
              },
              dataLabels: {
                enabled: false,
              },
              markers: {
                size: 4,
                hover: {
                  size: 6,
                },
              },
              xaxis: {
                type: 'datetime',
                categories: evolution.map((item) => item.date),
                labels: {
                  datetimeUTC: false,
                  format: 'dd/MM',
                },
              },
              yaxis: {
                title: {
                  text: 'Validadas',
                },
              },
              grid: {
                borderColor: '#eef1f7',
              },
            }}
            series={[
              {
                name: 'Atividades validadas',
                data: evolution.map((item) => item.validatedActivitiesCount),
              },
            ]}
          />
        )}
      </CardBody>
    </Card>
  );
};
